import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyUploaderModule } from '@vendasta/galaxy/uploader';
import { CustomizeDesignModule } from '../customize-design';
import { LogoComponent } from './logo/logo.component';

@NgModule({
  declarations: [LogoComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    GalaxyUploaderModule,
    MatIconModule,
    RouterModule,
    TranslateModule,
    MatButtonModule,
    CustomizeDesignModule,
    GalaxyAlertModule,
  ],
  exports: [LogoComponent],
})
export class WhitelabelModule {}
